import { Component } from '@angular/core';

@Component({
    template: `
        No connection to CASLink!
  `
})
export class NoServiceMessageComponent {
}
